import { CategoriaFaqOperatore, CategoriaFaqOperatorePublic, FaqOperatorePublic } from '@hm_app/@core/models/faq_operatore';
import { Component, OnInit } from '@angular/core';
import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';
import { FaqOperatore } from '@hm_app/@core/models/faq_operatore';
import * as _ from 'lodash-es';
import { NbAuthService } from '@nebular/auth';

@Component({
    selector: 'faq-operatori',
    templateUrl: './assistenza-faq-operatori.component.html',
    styleUrls: ['./assistenza-faq-operatori.component.scss'],
})

export class AssistenzaFaqOperatoriComponent implements OnInit {

    isAuthenticated: boolean;

    categorie: CategoriaFaqOperatorePublic[];
    domande: FaqOperatorePublic[];

    categoria_selected: CategoriaFaqOperatore;
    domanda_selected_mask: Map<number, boolean>;

    constructor(private hmService: HappyMammaService, private authService: NbAuthService) { }

    async ngOnInit() {
        try {
            this.isAuthenticated = await this.authService.isAuthenticated().toPromise();
            if (this.isAuthenticated) {
                this.categorie = await this.hmService.getAll<CategoriaFaqOperatorePublic>(CategoriaFaqOperatorePublic).toPromise();
            } else {
                this.categorie = await this.hmService.getAll<CategoriaFaqOperatorePublic>(CategoriaFaqOperatorePublic, { ispublic: true }).toPromise();
            }
            if (this.categorie && this.categorie.length) {
                this.categoria_selected = this.categorie[0];
                await this.cercaFaqPerCategoria();
            }
        } catch (error) {
            console.log(error);
        }
    }

    async cercaFaqPerCategoria() {
        let filters = {
            categoria: this.categoria_selected.id
        }
        if (!this.isAuthenticated)
            filters['ispublic'] = true;
        let data = await this.hmService.getAll<FaqOperatore>(FaqOperatore, filters, 0, 0, null, false, 'faq_operatore/public').toPromise();
        this.domande = data;
        this.domanda_selected_mask = new Map<number, boolean>();
    }
}
